"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _consts = require("../../consts");
require("./style.css");
var _login = require("../../servers/login");
var _accountNetSdk = require("account-net-sdk");
var _index = require("../../index");
var _AgreementModal = _interopRequireDefault(require("../AgreementModal"));
var _RealNameModal = _interopRequireDefault(require("../RealNameModal"));
var _excluded = ["updateLogin"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var LoginStatusMenu = function LoginStatusMenu(props) {
  var isLogin = props.isLogin,
    username = props.username,
    handleLoginClick = props.handleLoginClick;
  /**
   * 退出登录
   */
  var handleLoginOut = function handleLoginOut() {
    (0, _login.loginOut)({
      isWeGame: false
    }).then(function (res) {
      if (res && res.success) {
        window.location.reload();
      }
    });
  };
  return isLogin ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_menu_name",
    id: "gy_header_menu_name"
  }, "\u60A8\u597D\uFF0C", /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.ACCOUNT_OVERSEAS_URL,
    target: "_blank",
    className: "gy_header_username"
  }, username)), /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_header_line"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_loginOut",
    id: "gy_header_menu_loginOut",
    onClick: handleLoginOut
  }, "\u9000\u51FA")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_login",
    id: "gy_header_menu_login",
    onClick: function onClick() {
      return handleLoginClick();
    }
  }, "\u767B\u5F55"), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_header_line"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_register",
    id: "gy_header_menu_register"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.REGISTER_OVERSEAS_URL,
    target: "_blank"
  }, "\u6CE8\u518C"))));
};
var Overseas = function Overseas(props) {
  var updateLogin = props.updateLogin,
    ret = _objectWithoutProperties(props, _excluded);
  // 是否登录
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLogin = _useState2[0],
    setIsLogin = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    username = _useState4[0],
    setUsername = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loginVisible = _useState6[0],
    setLoginVisible = _useState6[1];
  // 显示补充三项
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    incompleteInfo = _useState8[0],
    setIncompleteInfo = _useState8[1];
  // 协议
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showAgreement = _useState10[0],
    setShowAgreement = _useState10[1];
  var handleLoginClick = function handleLoginClick() {
    setLoginVisible(true);
  };
  var handleLoginStatus = function handleLoginStatus() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'init';
    (0, _accountNetSdk.LoginStatus)(false).then(function (res) {
      props.onLoginStatus && props.onLoginStatus(res);
      if (!res.isSuccess && res.message == '请登录' || res.message == '登录过期') {
        if (updateLogin === null || updateLogin === void 0 ? void 0 : updateLogin.visibleLogin) {
          handleLoginClick();
        }
        setIsLogin(false);
        return;
      }
      // 协议
      if (!res.agreeStatus) {
        setShowAgreement(true);
      }
      if (type === 'init' && res.isLogin) {
        //登录状态还在
        setIsLogin(true);
        setUsername(res.account);
      }
    });
  };
  /**
   * 登录成功
   */
  var onSuccess = function onSuccess(props) {
    setIsLogin(true);
    setLoginVisible(false);
    setUsername(props.maskAccount);
    handleLoginStatus('refresh');
    if (props.type === 'qrcode') {
      window.location.reload();
    }
  };
  /**
   * 关闭登录
   */
  var onClose = function onClose() {
    setLoginVisible(false);
  };
  /**
   * 登录失败
   */
  var onError = function onError(res) {
    // if (res.error === LOGIN_STATUS.IMPERFECT) {
    //   const { uuid, account } = res.data;
    //   let url = `${ACCOUNT_OVERSEAS_URL}/account/CompleteInfo?uuid=${uuid}&account=${account}`;
    //   setIncompleteInfo(url);
    // }
    props.onLoginError && props.onLoginError(res);
  };
  (0, _react.useEffect)(function () {
    handleLoginStatus();
  }, []);
  (0, _react.useEffect)(function () {
    if (updateLogin && Object.keys(updateLogin).length) {
      handleLoginStatus();
    }
  }, [updateLogin]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_layout"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_logo",
    href: _consts.ACCOUNT_OVERSEAS_URL,
    id: "gy_header_logo",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _consts.LOGO_URL,
    alt: "\u5149\u5B87\u6E38\u620F"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_common_menu"
  }, isLogin && /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_menu_home",
    id: "gy_header_menu_personal_center",
    href: _consts.ACCOUNT_OVERSEAS_URL
  }, "\u4E2A\u4EBA\u4E2D\u5FC3"), /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_menu_home",
    id: "gy_header_menu_home",
    href: _consts.GYYX_OVERSEAS_URL
  }, "\u5B98\u7F51\u9996\u9875"), /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_menu_home",
    id: "gy_header_menu_game",
    href: _consts.PAY_OVERSEAS_URL
  }, "\u6E38\u620F\u5145\u503C"), /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_menu_home",
    id: "gy_header_menu_service",
    href: _consts.CUSTOMER_SERVICE_OVERSEAS_URL
  }, "\u5BA2\u670D\u4E2D\u5FC3")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_info_menu"
  }, /*#__PURE__*/_react.default.createElement(LoginStatusMenu, {
    isLogin: isLogin,
    username: username,
    handleLoginClick: handleLoginClick
  }))), loginVisible && /*#__PURE__*/_react.default.createElement(_index.Login, _objectSpread({
    onSuccess: onSuccess,
    onClose: onClose,
    onError: onError,
    useType: "overseas"
  }, ret)), showAgreement && /*#__PURE__*/_react.default.createElement(_AgreementModal.default, {
    onClose: setShowAgreement,
    loginMode: "DefaultLogin"
  }), incompleteInfo && /*#__PURE__*/_react.default.createElement(_RealNameModal.default, {
    content: "\u5C0A\u656C\u7684\u73A9\u5BB6\u60A8\u597D\uFF0C\u7531\u4E8E\u60A8\u8D26\u53F7\u5904\u4E8E\u5F02\u5E38\u72B6\u6001\uFF0C\u9700\u8865\u5168\u771F\u5B9E\u8EAB\u4EFD\u4FE1\u606F\u624D\u53EF\u4EE5\u7EE7\u7EED\u6E38\u620F\u3002",
    jumpUrl: incompleteInfo
  }));
};
var _default = Overseas;
exports.default = _default;